import { Box, Tab, Tabs } from '@mui/material';

import { CallbacksTab } from '~/components/callbacks/CallbacksTab';
import type { ServiceView } from '~/components/serviceHistory/serviceHistoryView';
import { useServiceView } from '~/components/serviceHistory/serviceHistoryView';
import { usePeriodWindow } from '~/components/serviceHistory/usePeriodWindow';
import { VisitsCompletionTab } from '~/components/visitsCompletion/VisitsCompletionTab';
import type { VisitPeriodScopeTarget } from '~/data/hooks/useMaintenanceVisitPeriods';

/**
 * The two month grids a service record is read through. They share a scope and a
 * period, so they sit under one tab with one period selector; they answer opposite
 * questions, so they do not share a cell.
 */
export function ServiceHistoryTab({
  scope,
  visitsEmptyMessage,
  callbacksEmptyMessage,
  alwaysShowProperty = false,
}: {
  scope: VisitPeriodScopeTarget;
  visitsEmptyMessage: string;
  callbacksEmptyMessage: string;
  alwaysShowProperty?: boolean;
}) {
  const [view, setView] = useServiceView();
  const [window, setWindow] = usePeriodWindow();

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', px: 3, pt: 1 }}>
        <Tabs
          value={view}
          onChange={(_event, next: ServiceView) => setView(next)}
          aria-label="Service history view"
        >
          <Tab value="visits" label="Maintenance visits" />
          <Tab value="callbacks" label="Callback/Emergency Visits" />
        </Tabs>
      </Box>
      {view === 'visits' ? (
        <VisitsCompletionTab
          scope={scope}
          emptyMessage={visitsEmptyMessage}
          window={window}
          alwaysShowProperty={alwaysShowProperty}
          onWindowChange={setWindow}
        />
      ) : (
        <CallbacksTab
          scope={scope}
          emptyMessage={callbacksEmptyMessage}
          window={window}
          alwaysShowProperty={alwaysShowProperty}
          onWindowChange={setWindow}
        />
      )}
    </Box>
  );
}
